import UseStoreHandler from "@/composables/handlers/UseStoreHandler";
import BaseModel from "./BaseModel";

/**
 * Instructor
 */
export default class Instructor extends BaseModel {
  constructor({
    id,
    user,
    status,
    name,
    title,
    description,
    links,
    instructor_photo,
    default_instructor
  }) {
    super();

    this.id = id || null;
    this.user = user || null;
    this.status = status || null;
    this.name = name || null;
    this.title = title || null;
    this.description = description || null;
    this.links = links || null;
    this.instructor_photo = instructor_photo || null;
    this.default_instructor = default_instructor || null;
  }

  /**
   * Gets links
   * @returns {Array}
   */
  getLinks() {
    return this.links ? JSON.parse(this.links) : [];
  }

  /**
   * Gets Instructor photo
   */
  getPhoto() {
    return this.instructor_photo ? `data:image/png;base64,${this.instructor_photo}` : require('@/assets/images/instructor.jpg');
  }

  /**
   * Gets this.title translated
   * @returns {string}
   */
  getTitleByLang(lang = null) {
    const title = JSON.parse(this.title) || {};

    if (!lang) {
      const contextStore = UseStoreHandler.getContextStore();
      lang = contextStore.getLang;
    }

    return title[lang] != undefined
      ? title[lang]
      : '';
  }

  /**
   * Gets this.description translated
   * @returns {string}
   */
  getDescriptionByLang(lang = null) {
    const description = JSON.parse(this.description) || {};

    if (!lang) {
      const contextStore = UseStoreHandler.getContextStore();
      lang = contextStore.getLang;
    }

    return description[lang] != undefined
      ? description[lang]
      : '';
  }
}
